// assets
import { CameraOutlined } from '@ant-design/icons';

// ==============================|| MENU ITEMS - CAMERA ||============================== //

const camera = {
    id: 'group-camera',
    title: 'Cameras',
    type: 'group',
    children: [
        {
            id: 'camera',
            title: 'Camera',
            type: 'item',
            url: '/camera',
            icon: CameraOutlined,
        },
    ],
};

export default camera;